// let listRequirements = [{ //餐品要求（没有特殊要求则不传）
//   index: '', // 所在索引  对应第N份餐品的要求（必传）
//   num: '', //数量 （相同餐品增加数量）（必传）
//   isScore: false, // 是否积分兑换餐品
//   propertys: [{ // 特殊要求集合
//     pid: '', // 特殊要求id（对应原餐品对象的requirements数组属性里的特殊要求对象里的uid）（必传）
//     items: [{ // 特殊要求集合
//       index: '', // 索引（对应原餐品里特殊要求选项的index）（必传）
//       num: '', //可选特殊要求的份数
//       alterNum: '', //可选特殊要求变动份数（没变动的项不用传）
//       alterPrice: '', //可选特殊要求变动价钱（DC会计算跟前端传的是否一致）
//     }]
//   }]
// }]

// import { parsePath } from './path';
import validator from './veriflcation';

const computedAlterPrice = (items, num) => {
  if (num === undefined || num === 0) {
    if (items.defaultNum > 0) {
      num = items.defaultNum;
    } else if (items.minNum >= 0) {
      num = items.minNum;
    } else {
      num = 1;
    }
  }
  let obj = {
    index: items.index,
    price: items.price,
    num
  };
  obj.alterPrice = num * items.price - items.defaultNum * items.price;
  obj.alterNum = (num - items.defaultNum);
  return obj;
}

/**
  * 添加每个特殊要求的方法
  * @param arr 要添加的特殊要求数组
  * @param type  1: 单选 2: 多选 3: 可选 4: 套餐单选 5: 套餐多选
  * @param req 源reauirements数组
  * @param path 父路径
  * @param num 数量
*/
const addItems = (req = false, arr, type = false, path, num) => {
  let option = [];
  for (let i = 0; i < arr.length; i ++) {
    const items = arr[i];
    let obj = {};
    if (type === 3) {
      obj = computedAlterPrice(items, num);
    } else if (type !== 3) {
      obj = computedAlterPrice(items, 1);
    } else {
      continue;
    }
    let _means = {};
    if (typeof type === 'number') {
      _means.type = type;
    }
    type !== 3 && req && (_means.items = req.items);
    _means.getPath = path + '.items[' + i + ']';
    // Object.defineProperty(obj, '_means', {
    //   value: _means
    // });
    obj._means = _means;
    option.push(obj);
  }
  return option;
}

// let listPaht = 'listRequirements-propertys-items';

/**
  * 添加新的商品，初始化新的商品数据
  * @param requirements 特殊要求数据
  * @param listReq 要添加数据的listRequirements数组
  * @param num 数量
*/
const addRequirements = (requirements, listReq, num, isGroup = false) => {
  let gPath = listReq._means.getPath;
  // 路径补全
  if (!isGroup && gPath.indexOf('listRequirements') < 0) {
    gPath += '.listRequirements';
  } else if (!isGroup && /listRequirements\[\d+\]$/.test(gPath)) {
    gPath = gPath.replace(/listRequirements\[\d+\]$/, 'listRequirements');
  }
  // 路径补全
  if (isGroup && gPath.indexOf('listPropertys') < 0) {
    gPath += '.listPropertys'
  } else if (isGroup && /listPropertys\[\d+\]$/.test(gPath)) {
    gPath = gPath.replace(/listPropertys\[\d+\]$/, 'listPropertys');
  }
  const index = listReq.length;
  const listRequirements = {
    index,
    num,
    isScore: requirements.isScore || false,
    propertys: [],
  };
  listRequirements._means = {
    getPath: gPath + '[' + index + ']',
    requirements: requirements
  };
  while (num !== 0) {
    const propertys = [];
    for (let i = 0; i < requirements.length; i ++) {
      const req = requirements[i];
      let option = [];
      let proPath = gPath + '[' + index + '].propertys[' + i + ']';
      if (req.isNeedSelected && req.type !== 3) {
        if (req.type === 0 && typeof req.isSingleRadio === 'boolean' || req.type < 3) {
          let type = req.type;
          if(type === 0 && req.isSingleRadio) {
            type = 1;
          } else if (type === 0 && !req.isSingleRadio) {
            type = 2;
          }
          option = addItems(req, [req.items[0]], type, proPath);
        } else if (req.type === undefined && typeof req.isSingleRadio === 'boolean') {
          option = addItems(req, [req.items[0]], req.type, proPath);
        }
      } else if (req.type === 3) {
        option = addItems(req, req.items, req.type, proPath);
      }
      if (!option.length) {
        continue;
      }
      let pro = {
        pid: req.uid,
        items: option
      }
      pro._means = { getPath: gPath + '[' + index + '].propertys[' + propertys.length + ']',  items: req.items };
      // propertys._means = { _getPath: proPath };
      // Object.defineProperty(pro, '_means', {
      //   value: { getPath: proPath }
      // });
      propertys.push(pro);
    }
    num --;
    if (!propertys.length) {
      continue;
    }
    listRequirements.propertys.push(...propertys);
  }
  // if (!listRequirements.propertys.length) {
  //   return;
  // }
  // listRequirements._means = { _getPath: path + '.listRequirements[' + index + ']' };
  // Object.defineProperty(listRequirements, '_means', {
  //   value: { getPath: 'listRequirements[' + index + ']' }
  // });
  return listRequirements;
}

export {
  addRequirements,
  computedAlterPrice,
  addItems
};

export default {
  addRequirements,
  computedAlterPrice,
  addItems
};


// WEBPACK FOOTER //
// ./../../plugins/cart/requirements.js